<template>
  <div>
    <div>
      <div class="vue-select-container" v-on:click="openDropdown()">
        <div
          class="vue-value-container"
          style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
        >
          <div class="vue-placeholder">
            <span
              v-if="criteriaData.Partner.length == 0 && criteriaData.search == ''"
            >{{criteriaData.label}}</span>
            <span v-if="criteriaData.search == ''">
              <span v-for="opt in criteriaData.Partner" :key="opt.Id">{{opt.Option}},</span>
            </span>
          </div>
        </div>
        <div class="vue-input">
          <input class="sear" v-model="criteriaData.search" type="text" />
        </div>
        <span class="arrow">
          <i class="fa fa-caret-down"></i>
        </span>
      </div>
      <div class="vue-dropdown-panel" v-show="criteriaData.showDropdownPartners">
        <div class="vue-dropdown-header">
          <div class="ey-select-all">
            <input
              id="All"
              class="k-checkbox form-control"
              @change="checkAll($event)"
              v-model="criteriaData.All"
              type="checkbox"
            />
            <label class="k-checkbox-label" for="All">Select All</label>
          </div>
        </div>
        <div class="vue-dropdown-panel-items">
          <div v-for="option in filteredPartners" :key="option.Id">
            <input
              v-bind:id="option.Id"
              name="partner"
              @change="check($event)"
              :value="option"
              class="k-checkbox form-control"
              type="checkbox"
              v-model="criteriaData.Partner"
            />
            <label name="partner" class="k-checkbox-label" v-bind:for="option.Id">{{option.Option}}</label>
          </div>
        </div>

        <div class="vue-dropdown-footer">
          <div style="padding:0 16px;">{{criteriaData.Partner.length}} Selected</div>
          <div>
            <button style="width:50%" class="btn btn-secondary" @click.prevent="Cancel">Cancel</button>
            <button style="width:50%" class="btn btn-primary" @click.prevent="SelectedPartner">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiSelectDropdown",
  props: {
    dropdownOptions: Object,
    criteriaData: Object
  },
  data: function() {
    return {};
  },
  computed: {
    filteredPartners: function() {
      var self = this;
      return self.dropdownOptions.Partner.filter(function(cust) {
        return (
          cust.Option.toLowerCase().indexOf(
            self.criteriaData.search.toLowerCase()
          ) >= 0
        );
      });
    }
  },
  methods: {
    SelectedPartner(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      this.criteriaData.showDropdownPartners = false;
    },
    Cancel(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      this.criteriaData.Partner = [];
      this.criteriaData.All = false;
      this.criteriaData.showDropdownPartners = false;
    },
    checkAll(e) {
      if (this.criteriaData.All)
        this.criteriaData.Partner = this.dropdownOptions.Partner;
      else this.criteriaData.Partner = [];
    },
    check(e) {
      if (
        this.criteriaData.Partner.length == this.dropdownOptions.Partner.length
      )
        this.criteriaData.All = true;
      else this.criteriaData.All = false;
    },
    openDropdown() {
      var scrollTop = $(window).scrollTop();
      var topOffset = $(".vue-select-container").offset().top;
      var relativeOffset = topOffset - scrollTop;
      var windowHeight = $(window).height();
      this.criteriaData.showDropdownPartners = true;
      $(".vue-dropdown-panel").width($(".vue-select-container").width() + 30);
      if (relativeOffset > windowHeight / 2) {
        $(".vue-dropdown-panel").addClass("reverse");
      } else {
        $(".vue-dropdown-panel").removeClass("reverse");
      }
    }
  }
};
</script>

<style>
</style>
